<template lang="pug">
input.input(v-bind:placeholder="placeholder" v-bind:value="value" v-mask="mask" v-on:input="input($event.target.value)")
</template>

<script>
export default {
  props: {
    mask: {
      required: true,
      type: [Object, String]
    },
    placeholder: {
      required: true,
      type: String
    },
    value: {
      required: true,
      type: String
    }
  },
  methods: {
    isValid () {
      return true
    },
    input (value) {
      if (value !== this.value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
